import "core-js/modules/es.array.concat";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    type: {
      type: String,
      default: 'image' // image：图片，audio：音频，video：视频，other：其他

    },
    token: {
      default: ''
    }
  },
  data: function data() {
    return {
      sourceFileList: [],
      fileList: [],
      lastFile: '',
      uploadOpts: {
        token: '',
        key: ''
      },
      upAction: process.env.VUE_APP_QNUPLOAD,
      dialogVisible: false
    };
  },
  methods: {
    open: function open() {
      if (!this.uploadOpts.token) {
        this.getQnToken();
      }

      this.dialogVisible = true;
    },
    closeDialog: function closeDialog() {
      this.dialogVisible = false; // this.$emit('update:dialogVisible', false)
    },
    handleSuccess: function handleSuccess() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.lastFile = "".concat(process.env.VUE_APP_QNHOST).concat(_this.uploadOpts.key);

                _this.fileList.push(_this.lastFile);

                console.log('file upload ok', _this.lastFile);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    beforeUpload: function beforeUpload(file) {
      if (!this.uploadOpts.token) {
        this.$message.error('请稍后再试，正在初始化');
        return false;
      }

      console.warn('beforeUpload', file);
      var limitSize = file.size / 1024 / 1024 < 50; // 最大上传100M

      if (limitSize) {
        var fname = YL.randStr(10);
        this.$set(this.uploadOpts, 'key', 'upload/' + fname);
      } else {
        this.$message.error('不得上传超过50M的文件');
        return false;
      }
    },
    onChancel: function onChancel() {
      this.$emit('cancel');
      this.closeDialog();
    },
    onConfirm: function onConfirm() {
      this.$emit('confirm', this.lastFile);
      this.closeDialog();
    },
    getQnToken: function getQnToken() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$api.QN_TOEKN();

              case 2:
                res = _context2.sent;

                _this2.$set(_this2.uploadOpts, process.env.VUE_APP_LOGIN_TOKEN, res.token);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  },
  mounted: function mounted() {
    console.warn('mounted', this.token);
    this.$set(this.uploadOpts, process.env.VUE_APP_LOGIN_TOKEN, this.token);
  }
};